function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { generateTableCells, getBlockCheckoutOnlyMinimumNightCells, getColumnBackgroundSelectedStyle, getColumnStatusStyle, getColumnVirtualStyle, getTableCell, getTableCellVirtualCondition, getToolTipPosition, onMouseDown as _onMouseDown, onMouseOver as _onMouseOver, onMouseUp, onScrollDate, onSectionRenderJumpToToday, onTouchEnd as _onTouchEnd, setSelectionByValue } from "./utils";
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { AutoSizer, Grid } from 'react-virtualized';
import "./style.less";
var DatePickerTable = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    selectionVisible = _useState2[0],
    setSelectionVisible = _useState2[1];
  var _useState3 = useState({
      key: '',
      status: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    arrivalUnavailableCell = _useState4[0],
    setArrivalUnavailableCell = _useState4[1];
  var _useState5 = useState({
      rowStartIndex: -1,
      rowEndIndex: -1,
      rowCurrentIndex: -1,
      columnStartIndex: -1,
      columnEndIndex: -1,
      columnCurrentIndex: -1
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    selection = _useState6[0],
    setSelection = _useState6[1];
  var firstSelection = useRef({
    rowStartIndex: -1,
    rowEndIndex: -1,
    rowCurrentIndex: -1,
    columnStartIndex: -1,
    columnEndIndex: -1,
    columnCurrentIndex: -1
  });
  var startY = useRef(0);
  var isScrolling = useRef(false);
  var blockCells = props.blockCells || [];
  var _useMemo = useMemo(function () {
      if (blockCells.length > 1) {
        return getBlockCheckoutOnlyMinimumNightCells(props.minRange, blockCells);
      }
      return {
        checkoutOnlyCells: [],
        unavailableDueToMinimumStayCells: [],
        updatedBlockCells: []
      };
    }, [props.blockCells, props.minRange]),
    checkoutOnlyCells = _useMemo.checkoutOnlyCells,
    unavailableDueToMinimumStayCells = _useMemo.unavailableDueToMinimumStayCells,
    updatedBlockCells = _useMemo.updatedBlockCells;
  var tableCells = useMemo(function () {
    if (Object.keys(props.monthDate).length !== 0) {
      return generateTableCells(props.monthDate, updatedBlockCells, checkoutOnlyCells, unavailableDueToMinimumStayCells);
    } else {
      return [];
    }
  }, [props.monthDate, updatedBlockCells, checkoutOnlyCells, unavailableDueToMinimumStayCells]);
  var init = useRef(false);
  useEffect(function () {
    onMouseUp(selection, tableCells, props.onSelect);
  }, [selectionVisible]);
  useEffect(function () {
    if (props.value.length > 0 && tableCells.length > 0) {
      setSelectionByValue(tableCells, props.value, setSelection, firstSelection);
      if (props.value.length === 1) {
        setSelectionVisible(true);
      }
    }
  }, [tableCells]);

  // @ts-ignore
  useImperativeHandle(ref, function () {
    return {
      forceClearSelect: function forceClearSelect() {
        setSelection({
          rowStartIndex: -1,
          rowEndIndex: -1,
          rowCurrentIndex: -1,
          columnStartIndex: -1,
          columnEndIndex: -1,
          columnCurrentIndex: -1
        });
      }
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "date-picker-table-container",
    style: {
      height: props.tableHeight
    }
  }, /*#__PURE__*/React.createElement(AutoSizer, null, function (_ref) {
    var width = _ref.width,
      height = _ref.height;
    var cellHeight = props.cellHeightMonthly && props.cellHeightMonthly > width / 7 ? props.cellHeightMonthly : width / 7;
    var cellWidth = width / 7;
    return /*#__PURE__*/React.createElement(Grid, {
      className: "date-picker-date-value-container",
      width: width,
      height: height,
      columnCount: 7,
      columnWidth: cellWidth,
      rowCount: tableCells.length / 7,
      rowHeight: cellHeight,
      clientHeight: props.clientHeight,
      clientWidth: props.clientWidth,
      onSectionRendered: function onSectionRendered() {
        onSectionRenderJumpToToday(init, props.todayScrollTop, props.monthDate, props.setCustomScrollTop, cellHeight);
      },
      onScroll: function onScroll(params) {
        onScrollDate(params, cellHeight, tableCells, props);
        props.onScroll(params);
      },
      scrollHeight: props.scrollHeight,
      scrollLeft: props.scrollLeft,
      scrollTop: props.scrollTop,
      scrollWidth: props.scrollWidth,
      cellRenderer: function cellRenderer(_ref2) {
        var columnIndex = _ref2.columnIndex,
          key = _ref2.key,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style;
        var tableCell = getTableCell(tableCells, rowIndex, columnIndex);
        return /*#__PURE__*/React.createElement("div", {
          key: key,
          className: "date-picker-table-row-column-container\n                  ".concat(getColumnBackgroundSelectedStyle(rowIndex, columnIndex, selection), "\n                  ").concat(getColumnStatusStyle(tableCells, tableCell, firstSelection, props.minRange, props.maxRange, blockCells, checkoutOnlyCells), "\n                  ").concat(getColumnVirtualStyle(tableCells, rowIndex, columnIndex)),
          style: style,
          onMouseDown: function onMouseDown() {
            return _onMouseDown(rowIndex, columnIndex, selectionVisible, setSelectionVisible, setSelection, tableCells, tableCell, firstSelection, props.minRange, props.maxRange, blockCells, checkoutOnlyCells, setArrivalUnavailableCell);
          },
          onMouseOver: function onMouseOver() {
            return _onMouseOver(rowIndex, columnIndex, selectionVisible, selection, setSelection, tableCells, tableCell, firstSelection, props.minRange, props.maxRange, blockCells, checkoutOnlyCells, setArrivalUnavailableCell);
          },
          onTouchStart: function onTouchStart(event) {
            var touch = event.touches[0];
            startY.current = touch.clientY;
            isScrolling.current = false;
          },
          onTouchMove: function onTouchMove(event) {
            var touch = event.touches[0];
            if (Math.abs(touch.clientY - startY.current) > 10) {
              isScrolling.current = true;
            }
          },
          onTouchEnd: function onTouchEnd() {
            if (isScrolling.current) return;
            _onTouchEnd(rowIndex, columnIndex, selectionVisible, setSelectionVisible, setSelection, selection, tableCells, tableCell, firstSelection, props.minRange, props.maxRange, blockCells, checkoutOnlyCells, setArrivalUnavailableCell);
          }
        }, arrivalUnavailableCell.key === key && arrivalUnavailableCell.status === 'CheckoutOnly' && /*#__PURE__*/React.createElement("div", {
          className: "date-picker-table-row-column-arrival-unavailable-tooltip ".concat(getToolTipPosition(tableCell))
        }, /*#__PURE__*/React.createElement("p", null, "Checkout only")), arrivalUnavailableCell.key === key && arrivalUnavailableCell.status === 'UnavailableDueToMinimumStay' && /*#__PURE__*/React.createElement("div", {
          className: "date-picker-table-row-column-arrival-unavailable-tooltip ".concat(getToolTipPosition(tableCell))
        }, /*#__PURE__*/React.createElement("p", null, "".concat(props.minRange, " nights minimum"))), /*#__PURE__*/React.createElement("div", {
          className: "date-picker-table-row-column-content-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "date-picker-table-row-column-content-wrapper"
        }, getTableCellVirtualCondition(tableCells, rowIndex, columnIndex) && /*#__PURE__*/React.createElement("div", {
          className: "date-picker-table-row-column-content-virtual-wrapper"
        }, /*#__PURE__*/React.createElement("span", {
          className: "date-picker-table-row-column-content-virtual-text"
        }, tableCell === null || tableCell === void 0 ? void 0 : tableCell.value)), /*#__PURE__*/React.createElement("p", {
          className: "date-picker-table-row-column-content-day"
        }, tableCell === null || tableCell === void 0 ? void 0 : tableCell.day))));
      }
    });
  }));
});
export default DatePickerTable;